import { ZestimateTableData } from '../ZestimateTable/ZestimateTable';

/**
 * Zestimate accuracy data for on-market (active listings) homes
 */
export const ZESTIMATE_DATA_ON_MARKET: Record<string, ZestimateTableData> = {
    'Top Metro Areas': {
        headers: [
            'Metropolitan Area',
            'Median Error',
            'Homes With Zestimates',
            'Within 5% of Sales Price',
            'Within 10% of Sales Price',
            'Within 20% of Sales Price',
        ],
        data: [
            {
                'Metropolitan Area': 'Atlanta',
                'Median Error': '1.45%',
                'Homes With Zestimates': '45.0 K',
                'Within 5% of Sale Price': '88.34%',
                'Within 10% of Sale Price': '96.58%',
                'Within 20% of Sale Price': '98.96%',
            },
            {
                'Metropolitan Area': 'Austin',
                'Median Error': '1.85%',
                'Homes With Zestimates': '22.5 K',
                'Within 5% of Sale Price': '85.03%',
                'Within 10% of Sale Price': '95.41%',
                'Within 20% of Sale Price': '99.08%',
            },
            {
                'Metropolitan Area': 'Baltimore',
                'Median Error': '1.62%',
                'Homes With Zestimates': '9.6 K',
                'Within 5% of Sale Price': '87.22%',
                'Within 10% of Sale Price': '96.59%',
                'Within 20% of Sale Price': '99.07%',
            },
            {
                'Metropolitan Area': 'Boston',
                'Median Error': '2.32%',
                'Homes With Zestimates': '11.2 K',
                'Within 5% of Sale Price': '78.87%',
                'Within 10% of Sale Price': '95.12%',
                'Within 20% of Sale Price': '99.46%',
            },
            {
                'Metropolitan Area': 'Charlotte',
                'Median Error': '1.47%',
                'Homes With Zestimates': '19.2 K',
                'Within 5% of Sale Price': '90.17%',
                'Within 10% of Sale Price': '97.59%',
                'Within 20% of Sale Price': '99.41%',
            },
            {
                'Metropolitan Area': 'Chicago',
                'Median Error': '1.95%',
                'Homes With Zestimates': '38.8 K',
                'Within 5% of Sale Price': '83.32%',
                'Within 10% of Sale Price': '96.14%',
                'Within 20% of Sale Price': '99.21%',
            },
            {
                'Metropolitan Area': 'Cincinnati',
                'Median Error': '1.85%',
                'Homes With Zestimates': '9.7 K',
                'Within 5% of Sale Price': '85.50%',
                'Within 10% of Sale Price': '96.59%',
                'Within 20% of Sale Price': '99.21%',
            },
            {
                'Metropolitan Area': 'Cleveland',
                'Median Error': '2.30%',
                'Homes With Zestimates': '7.9 K',
                'Within 5% of Sale Price': '79.15%',
                'Within 10% of Sale Price': '94.93%',
                'Within 20% of Sale Price': '99.08%',
            },
            {
                'Metropolitan Area': 'Colorado Springs',
                'Median Error': '1.10%',
                'Homes With Zestimates': '6.2 K',
                'Within 5% of Sale Price': '93.82%',
                'Within 10% of Sale Price': '98.38%',
                'Within 20% of Sale Price': '99.62%',
            },
            {
                'Metropolitan Area': 'Dallas-Fort Worth',
                'Median Error': '1.58%',
                'Homes With Zestimates': '61.5 K',
                'Within 5% of Sale Price': '88.09%',
                'Within 10% of Sale Price': '96.67%',
                'Within 20% of Sale Price': '99.08%',
            },
            {
                'Metropolitan Area': 'Denver',
                'Median Error': '1.19%',
                'Homes With Zestimates': '19.7 K',
                'Within 5% of Sale Price': '93.04%',
                'Within 10% of Sale Price': '98.41%',
                'Within 20% of Sale Price': '99.67%',
            },
            {
                'Metropolitan Area': 'Detroit',
                'Median Error': '2.17%',
                'Homes With Zestimates': '14.4 K',
                'Within 5% of Sale Price': '80.35%',
                'Within 10% of Sale Price': '94.93%',
                'Within 20% of Sale Price': '98.89%',
            },
            {
                'Metropolitan Area': 'Fort Collins',
                'Median Error': '1.16%',
                'Homes With Zestimates': '2.9 K',
                'Within 5% of Sale Price': '93.93%',
                'Within 10% of Sale Price': '98.30%',
                'Within 20% of Sale Price': '99.78%',
            },
            {
                'Metropolitan Area': 'Houston',
                'Median Error': '1.87%',
                'Homes With Zestimates': '57.8 K',
                'Within 5% of Sale Price': '84.06%',
                'Within 10% of Sale Price': '94.65%',
                'Within 20% of Sale Price': '98.69%',
            },
            {
                'Metropolitan Area': 'Jacksonville',
                'Median Error': '1.70%',
                'Homes With Zestimates': '15.4 K',
                'Within 5% of Sale Price': '86.77%',
                'Within 10% of Sale Price': '95.95%',
                'Within 20% of Sale Price': '98.81%',
            },
            {
                'Metropolitan Area': 'Kansas City',
                'Median Error': '1.72%',
                'Homes With Zestimates': '10.0 K',
                'Within 5% of Sale Price': '85.86%',
                'Within 10% of Sale Price': '96.77%',
                'Within 20% of Sale Price': '99.32%',
            },
            {
                'Metropolitan Area': 'Las Vegas',
                'Median Error': '1.21%',
                'Homes With Zestimates': '18.5 K',
                'Within 5% of Sale Price': '92.03%',
                'Within 10% of Sale Price': '97.76%',
                'Within 20% of Sale Price': '99.35%',
            },
            {
                'Metropolitan Area': 'Los Angeles-Long Beach-Anaheim',
                'Median Error': '1.96%',
                'Homes With Zestimates': '37.0 K',
                'Within 5% of Sale Price': '81.74%',
                'Within 10% of Sale Price': '94.94%',
                'Within 20% of Sale Price': '99.03%',
            },
            {
                'Metropolitan Area': 'Miami-Fort Lauderdale',
                'Median Error': '2.19%',
                'Homes With Zestimates': '65.3 K',
                'Within 5% of Sale Price': '82.03%',
                'Within 10% of Sale Price': '94.81%',
                'Within 20% of Sale Price': '98.67%',
            },
            {
                'Metropolitan Area': 'Minneapolis-St Paul',
                'Median Error': '1.67%',
                'Homes With Zestimates': '16.4 K',
                'Within 5% of Sale Price': '87.14%',
                'Within 10% of Sale Price': '97.57%',
                'Within 20% of Sale Price': '99.51%',
            },
            {
                'Metropolitan Area': 'Nashville',
                'Median Error': '1.33%',
                'Homes With Zestimates': '20.2 K',
                'Within 5% of Sale Price': '88.92%',
                'Within 10% of Sale Price': '96.45%',
                'Within 20% of Sale Price': '98.92%',
            },
            {
                'Metropolitan Area': 'New York',
                'Median Error': '2.66%',
                'Homes With Zestimates': '60.0 K',
                'Within 5% of Sale Price': '74.03%',
                'Within 10% of Sale Price': '93.17%',
                'Within 20% of Sale Price': '98.81%',
            },
            {
                'Metropolitan Area': 'Orlando',
                'Median Error': '1.59%',
                'Homes With Zestimates': '24.3 K',
                'Within 5% of Sale Price': '88.40%',
                'Within 10% of Sale Price': '96.94%',
                'Within 20% of Sale Price': '99.20%',
            },
            {
                'Metropolitan Area': 'Philadelphia',
                'Median Error': '2.16%',
                'Homes With Zestimates': '18.7 K',
                'Within 5% of Sale Price': '80.30%',
                'Within 10% of Sale Price': '94.93%',
                'Within 20% of Sale Price': '98.85%',
            },
            {
                'Metropolitan Area': 'Phoenix',
                'Median Error': '1.26%',
                'Homes With Zestimates': '37.9 K',
                'Within 5% of Sale Price': '91.19%',
                'Within 10% of Sale Price': '97.81%',
                'Within 20% of Sale Price': '99.51%',
            },
            {
                'Metropolitan Area': 'Pittsburgh',
                'Median Error': '2.22%',
                'Homes With Zestimates': '7.5 K',
                'Within 5% of Sale Price': '79.87%',
                'Within 10% of Sale Price': '94.79%',
                'Within 20% of Sale Price': '99.21%',
            },
            {
                'Metropolitan Area': 'Portland',
                'Median Error': '1.38%',
                'Homes With Zestimates': '12.9 K',
                'Within 5% of Sale Price': '89.96%',
                'Within 10% of Sale Price': '97.55%',
                'Within 20% of Sale Price': '99.42%',
            },
            {
                'Metropolitan Area': 'Raleigh',
                'Median Error': '1.15%',
                'Homes With Zestimates': '11.4 K',
                'Within 5% of Sale Price': '92.61%',
                'Within 10% of Sale Price': '98.45%',
                'Within 20% of Sale Price': '99.66%',
            },
            {
                'Metropolitan Area': 'Riverside',
                'Median Error': '1.55%',
                'Homes With Zestimates': '24.8 K',
                'Within 5% of Sale Price': '87.76%',
                'Within 10% of Sale Price': '96.31%',
                'Within 20% of Sale Price': '98.49%',
            },
            {
                'Metropolitan Area': 'Sacramento',
                'Median Error': '1.47%',
                'Homes With Zestimates': '9.8 K',
                'Within 5% of Sale Price': '88.49%',
                'Within 10% of Sale Price': '96.56%',
                'Within 20% of Sale Price': '98.95%',
            },
            {
                'Metropolitan Area': 'San Antonio',
                'Median Error': '1.58%',
                'Homes With Zestimates': '23.5 K',
                'Within 5% of Sale Price': '84.75%',
                'Within 10% of Sale Price': '93.68%',
                'Within 20% of Sale Price': '97.90%',
            },
            {
                'Metropolitan Area': 'San Diego',
                'Median Error': '1.69%',
                'Homes With Zestimates': '11.9 K',
                'Within 5% of Sale Price': '87.34%',
                'Within 10% of Sale Price': '96.63%',
                'Within 20% of Sale Price': '99.04%',
            },
            {
                'Metropolitan Area': 'San Francisco',
                'Median Error': '2.64%',
                'Homes With Zestimates': '11.0 K',
                'Within 5% of Sale Price': '73.45%',
                'Within 10% of Sale Price': '92.07%',
                'Within 20% of Sale Price': '98.57%',
            },
            {
                'Metropolitan Area': 'Seattle',
                'Median Error': '1.53%',
                'Homes With Zestimates': '16.4 K',
                'Within 5% of Sale Price': '88.13%',
                'Within 10% of Sale Price': '97.05%',
                'Within 20% of Sale Price': '99.53%',
            },
            {
                'Metropolitan Area': 'St. Louis',
                'Median Error': '2.21%',
                'Homes With Zestimates': '9.7 K',
                'Within 5% of Sale Price': '79.92%',
                'Within 10% of Sale Price': '94.63%',
                'Within 20% of Sale Price': '99.01%',
            },
            {
                'Metropolitan Area': 'Tampa',
                'Median Error': '1.75%',
                'Homes With Zestimates': '32.4 K',
                'Within 5% of Sale Price': '86.26%',
                'Within 10% of Sale Price': '96.03%',
                'Within 20% of Sale Price': '98.93%',
            },
            {
                'Metropolitan Area': 'Tucson',
                'Median Error': '1.37%',
                'Homes With Zestimates': '7.8 K',
                'Within 5% of Sale Price': '90.88%',
                'Within 10% of Sale Price': '98.17%',
                'Within 20% of Sale Price': '99.63%',
            },
            {
                'Metropolitan Area': 'Washington',
                'Median Error': '1.36%',
                'Homes With Zestimates': '23.3 K',
                'Within 5% of Sale Price': '90.72%',
                'Within 10% of Sale Price': '98.10%',
                'Within 20% of Sale Price': '99.56%',
            },
        ],
    },
    States: {
        headers: [
            'State',
            'Median Error',
            'Homes With Zestimates',
            'Within 5% of Sales Price',
            'Within 10% of Sales Price',
            'Within 20% of Sales Price',
        ],
        data: [
            {
                State: 'Alabama',
                'Median Error': '1.58%',
                'Homes With Zestimates': '32.1 K',
                'Within 5% of Sale Price': '86.00%',
                'Within 10% of Sale Price': '95.88%',
                'Within 20% of Sale Price': '98.81%',
            },
            {
                State: 'Alaska',
                'Median Error': 'NA',
                'Homes With Zestimates': '2.7 K',
                'Within 5% of Sale Price': 'NA',
                'Within 10% of Sale Price': 'NA',
                'Within 20% of Sale Price': 'NA',
            },
            {
                State: 'Arizona',
                'Median Error': '1.33%',
                'Homes With Zestimates': '57.0 K',
                'Within 5% of Sale Price': '90.57%',
                'Within 10% of Sale Price': '97.61%',
                'Within 20% of Sale Price': '99.44%',
            },
            {
                State: 'Arkansas',
                'Median Error': '1.70%',
                'Homes With Zestimates': '18.5 K',
                'Within 5% of Sale Price': '85.65%',
                'Within 10% of Sale Price': '95.65%',
                'Within 20% of Sale Price': '98.73%',
            },
            {
                State: 'California',
                'Median Error': '1.78%',
                'Homes With Zestimates': '134.4 K',
                'Within 5% of Sale Price': '84.02%',
                'Within 10% of Sale Price': '95.45%',
                'Within 20% of Sale Price': '98.85%',
            },
            {
                State: 'Colorado',
                'Median Error': '1.24%',
                'Homes With Zestimates': '44.7 K',
                'Within 5% of Sale Price': '92.06%',
                'Within 10% of Sale Price': '98.01%',
                'Within 20% of Sale Price': '99.54%',
            },
            {
                State: 'Connecticut',
                'Median Error': '2.93%',
                'Homes With Zestimates': '10.2 K',
                'Within 5% of Sale Price': '71.98%',
                'Within 10% of Sale Price': '93.09%',
                'Within 20% of Sale Price': '99.11%',
            },
            {
                State: 'Delaware',
                'Median Error': '1.71%',
                'Homes With Zestimates': '4.8 K',
                'Within 5% of Sale Price': '83.56%',
                'Within 10% of Sale Price': '92.01%',
                'Within 20% of Sale Price': '96.39%',
            },
            {
                State: 'District of Columbia',
                'Median Error': '1.66%',
                'Homes With Zestimates': '4.1 K',
                'Within 5% of Sale Price': '87.22%',
                'Within 10% of Sale Price': '96.88%',
                'Within 20% of Sale Price': '99.29%',
            },
            {
                State: 'Florida',
                'Median Error': '1.89%',
                'Homes With Zestimates': '260.0 K',
                'Within 5% of Sale Price': '84.76%',
                'Within 10% of Sale Price': '95.64%',
                'Within 20% of Sale Price': '98.85%',
            },
            {
                State: 'Georgia',
                'Median Error': '1.49%',
                'Homes With Zestimates': '75.1 K',
                'Within 5% of Sale Price': '87.65%',
                'Within 10% of Sale Price': '96.30%',
                'Within 20% of Sale Price': '98.89%',
            },
            {
                State: 'Hawaii',
                'Median Error': '1.86%',
                'Homes With Zestimates': '8.8 K',
                'Within 5% of Sale Price': '84.89%',
                'Within 10% of Sale Price': '95.54%',
                'Within 20% of Sale Price': '99.22%',
            },
            {
                State: 'Idaho',
                'Median Error': '1.17%',
                'Homes With Zestimates': '16.9 K',
                'Within 5% of Sale Price': '91.52%',
                'Within 10% of Sale Price': '97.69%',
                'Within 20% of Sale Price': '99.46%',
            },
            {
                State: 'Illinois',
                'Median Error': '2.07%',
                'Homes With Zestimates': '45.8 K',
                'Within 5% of Sale Price': '81.76%',
                'Within 10% of Sale Price': '95.66%',
                'Within 20% of Sale Price': '99.15%',
            },
            {
                State: 'Indiana',
                'Median Error': '1.67%',
                'Homes With Zestimates': '28.3 K',
                'Within 5% of Sale Price': '86.37%',
                'Within 10% of Sale Price': '96.11%',
                'Within 20% of Sale Price': '99.02%',
            },
            {
                State: 'Iowa',
                'Median Error': '1.58%',
                'Homes With Zestimates': '14.6 K',
                'Within 5% of Sale Price': '87.32%',
                'Within 10% of Sale Price': '96.82%',
                'Within 20% of Sale Price': '99.18%',
            },
            {
                State: 'Kansas',
                'Median Error': '1.80%',
                'Homes With Zestimates': '11.5 K',
                'Within 5% of Sale Price': '85.18%',
                'Within 10% of Sale Price': '96.32%',
                'Within 20% of Sale Price': '99.27%',
            },
            {
                State: 'Kentucky',
                'Median Error': '1.76%',
                'Homes With Zestimates': '18.3 K',
                'Within 5% of Sale Price': '85.83%',
                'Within 10% of Sale Price': '96.30%',
                'Within 20% of Sale Price': '98.92%',
            },
            {
                State: 'Louisiana',
                'Median Error': '1.68%',
                'Homes With Zestimates': '22.0 K',
                'Within 5% of Sale Price': '86.18%',
                'Within 10% of Sale Price': '95.86%',
                'Within 20% of Sale Price': '98.78%',
            },
            {
                State: 'Maine',
                'Median Error': '2.37%',
                'Homes With Zestimates': '6.8 K',
                'Within 5% of Sale Price': '77.70%',
                'Within 10% of Sale Price': '93.94%',
                'Within 20% of Sale Price': '98.64%',
            },
            {
                State: 'Maryland',
                'Median Error': '1.53%',
                'Homes With Zestimates': '22.9 K',
                'Within 5% of Sale Price': '88.11%',
                'Within 10% of Sale Price': '96.97%',
                'Within 20% of Sale Price': '99.22%',
            },
            {
                State: 'Massachusetts',
                'Median Error': '2.34%',
                'Homes With Zestimates': '16.7 K',
                'Within 5% of Sale Price': '79.08%',
                'Within 10% of Sale Price': '95.16%',
                'Within 20% of Sale Price': '99.38%',
            },
            {
                State: 'Michigan',
                'Median Error': '2.16%',
                'Homes With Zestimates': '33.5 K',
                'Within 5% of Sale Price': '80.19%',
                'Within 10% of Sale Price': '94.87%',
                'Within 20% of Sale Price': '98.93%',
            },
            {
                State: 'Minnesota',
                'Median Error': '1.77%',
                'Homes With Zestimates': '23.9 K',
                'Within 5% of Sale Price': '85.68%',
                'Within 10% of Sale Price': '96.91%',
                'Within 20% of Sale Price': '99.39%',
            },
            {
                State: 'Mississippi',
                'Median Error': '1.59%',
                'Homes With Zestimates': '11.2 K',
                'Within 5% of Sale Price': '86.31%',
                'Within 10% of Sale Price': '95.77%',
                'Within 20% of Sale Price': '98.86%',
            },
            {
                State: 'Missouri',
                'Median Error': '1.96%',
                'Homes With Zestimates': '28.8 K',
                'Within 5% of Sale Price': '82.93%',
                'Within 10% of Sale Price': '95.48%',
                'Within 20% of Sale Price': '98.93%',
            },
            {
                State: 'Montana',
                'Median Error': '1.95%',
                'Homes With Zestimates': '6.6 K',
                'Within 5% of Sale Price': '84.17%',
                'Within 10% of Sale Price': '96.00%',
                'Within 20% of Sale Price': '99.15%',
            },
            {
                State: 'Nebraska',
                'Median Error': '1.45%',
                'Homes With Zestimates': '8.8 K',
                'Within 5% of Sale Price': '88.68%',
                'Within 10% of Sale Price': '97.03%',
                'Within 20% of Sale Price': '99.14%',
            },
            {
                State: 'Nevada',
                'Median Error': '1.23%',
                'Homes With Zestimates': '23.5 K',
                'Within 5% of Sale Price': '91.63%',
                'Within 10% of Sale Price': '97.68%',
                'Within 20% of Sale Price': '99.36%',
            },
            {
                State: 'New Hampshire',
                'Median Error': '2.08%',
                'Homes With Zestimates': '5.3 K',
                'Within 5% of Sale Price': '81.15%',
                'Within 10% of Sale Price': '95.34%',
                'Within 20% of Sale Price': '99.05%',
            },
            {
                State: 'New Jersey',
                'Median Error': '2.59%',
                'Homes With Zestimates': '31.2 K',
                'Within 5% of Sale Price': '75.19%',
                'Within 10% of Sale Price': '93.94%',
                'Within 20% of Sale Price': '99.07%',
            },
            {
                State: 'New Mexico',
                'Median Error': '1.46%',
                'Homes With Zestimates': '9.8 K',
                'Within 5% of Sale Price': '88.67%',
                'Within 10% of Sale Price': '97.08%',
                'Within 20% of Sale Price': '99.30%',
            },
            {
                State: 'New York',
                'Median Error': '2.76%',
                'Homes With Zestimates': '52.8 K',
                'Within 5% of Sale Price': '72.85%',
                'Within 10% of Sale Price': '92.18%',
                'Within 20% of Sale Price': '98.54%',
            },
            {
                State: 'North Carolina',
                'Median Error': '1.37%',
                'Homes With Zestimates': '74.3 K',
                'Within 5% of Sale Price': '89.41%',
                'Within 10% of Sale Price': '97.17%',
                'Within 20% of Sale Price': '99.21%',
            },
            {
                State: 'North Dakota',
                'Median Error': '1.48%',
                'Homes With Zestimates': '3.1 K',
                'Within 5% of Sale Price': '89.44%',
                'Within 10% of Sale Price': '97.18%',
                'Within 20% of Sale Price': '99.17%',
            },
            {
                State: 'Ohio',
                'Median Error': '2.03%',
                'Homes With Zestimates': '44.5 K',
                'Within 5% of Sale Price': '82.01%',
                'Within 10% of Sale Price': '95.34%',
                'Within 20% of Sale Price': '98.90%',
            },
            {
                State: 'Oklahoma',
                'Median Error': '1.57%',
                'Homes With Zestimates': '25.9 K',
                'Within 5% of Sale Price': '86.73%',
                'Within 10% of Sale Price': '95.92%',
                'Within 20% of Sale Price': '98.85%',
            },
            {
                State: 'Oregon',
                'Median Error': '1.45%',
                'Homes With Zestimates': '23.2 K',
                'Within 5% of Sale Price': '89.15%',
                'Within 10% of Sale Price': '97.34%',
                'Within 20% of Sale Price': '99.29%',
            },
            {
                State: 'Pennsylvania',
                'Median Error': '2.17%',
                'Homes With Zestimates': '38.3 K',
                'Within 5% of Sale Price': '79.59%',
                'Within 10% of Sale Price': '94.89%',
                'Within 20% of Sale Price': '99.04%',
            },
            {
                State: 'Rhode Island',
                'Median Error': '2.29%',
                'Homes With Zestimates': '3.9 K',
                'Within 5% of Sale Price': '79.47%',
                'Within 10% of Sale Price': '94.93%',
                'Within 20% of Sale Price': '98.86%',
            },
            {
                State: 'South Carolina',
                'Median Error': '1.42%',
                'Homes With Zestimates': '49.6 K',
                'Within 5% of Sale Price': '89.39%',
                'Within 10% of Sale Price': '97.11%',
                'Within 20% of Sale Price': '99.29%',
            },
            {
                State: 'South Dakota',
                'Median Error': '1.56%',
                'Homes With Zestimates': '4.8 K',
                'Within 5% of Sale Price': '88.31%',
                'Within 10% of Sale Price': '96.89%',
                'Within 20% of Sale Price': '99.16%',
            },
            {
                State: 'Tennessee',
                'Median Error': '1.56%',
                'Homes With Zestimates': '53.4 K',
                'Within 5% of Sale Price': '86.82%',
                'Within 10% of Sale Price': '95.94%',
                'Within 20% of Sale Price': '98.69%',
            },
            {
                State: 'Texas',
                'Median Error': '1.74%',
                'Homes With Zestimates': '228.1 K',
                'Within 5% of Sale Price': '85.41%',
                'Within 10% of Sale Price': '95.31%',
                'Within 20% of Sale Price': '98.72%',
            },
            {
                State: 'Utah',
                'Median Error': '1.19%',
                'Homes With Zestimates': '28.3 K',
                'Within 5% of Sale Price': '92.11%',
                'Within 10% of Sale Price': '98.04%',
                'Within 20% of Sale Price': '99.53%',
            },
            {
                State: 'Vermont',
                'Median Error': '2.27%',
                'Homes With Zestimates': '3.2 K',
                'Within 5% of Sale Price': '79.27%',
                'Within 10% of Sale Price': '94.13%',
                'Within 20% of Sale Price': '98.88%',
            },
            {
                State: 'Virginia',
                'Median Error': '1.38%',
                'Homes With Zestimates': '35.0 K',
                'Within 5% of Sale Price': '89.28%',
                'Within 10% of Sale Price': '97.37%',
                'Within 20% of Sale Price': '99.33%',
            },
            {
                State: 'Washington',
                'Median Error': '1.44%',
                'Homes With Zestimates': '37.8 K',
                'Within 5% of Sale Price': '88.93%',
                'Within 10% of Sale Price': '97.04%',
                'Within 20% of Sale Price': '99.33%',
            },
            {
                State: 'West Virginia',
                'Median Error': '1.97%',
                'Homes With Zestimates': '5.2 K',
                'Within 5% of Sale Price': '80.88%',
                'Within 10% of Sale Price': '94.99%',
                'Within 20% of Sale Price': '98.73%',
            },
            {
                State: 'Wisconsin',
                'Median Error': '2.42%',
                'Homes With Zestimates': '20.2 K',
                'Within 5% of Sale Price': '77.00%',
                'Within 10% of Sale Price': '94.53%',
                'Within 20% of Sale Price': '99.18%',
            },
            {
                State: 'Wyoming',
                'Median Error': '1.51%',
                'Homes With Zestimates': '3.4 K',
                'Within 5% of Sale Price': '88.78%',
                'Within 10% of Sale Price': '97.04%',
                'Within 20% of Sale Price': '99.00%',
            },
        ],
    },
    National: {
        headers: [
            'Region',
            'Median Error',
            'Homes With Zestimates',
            'Within 5% of Sales Price',
            'Within 10% of Sales Price',
            'Within 20% of Sales Price',
        ],
        data: [
            {
                Region: 'All 50 States',
                'Median Error': '1.74%',
                'Homes With Zestimates': '1.8 M',
                'Within 5% of Sale Price': '85.01%',
                'Within 10% of Sale Price': '95.92%',
                'Within 20% of Sale Price': '99.02%',
            },
        ],
    },
};

/**
 * Zestimate accuracy data for off-market homes
 */
export const ZESTIMATE_DATA_OFF_MARKET: Record<string, ZestimateTableData> = {
    'Top Metro Areas': {
        headers: [
            'Metropolitan Area',
            'Median Error',
            'Homes With Zestimates',
            'Within 5% of Sales Price',
            'Within 10% of Sales Price',
            'Within 20% of Sales Price',
        ],
        data: [
            {
                'Metropolitan Area': 'Atlanta',
                'Median Error': '6.56%',
                'Homes With Zestimates': '2.2 M',
                'Within 5% of Sale Price': '40.52%',
                'Within 10% of Sale Price': '65.94%',
                'Within 20% of Sale Price': '86.58%',
            },
            {
                'Metropolitan Area': 'Austin',
                'Median Error': '6.54%',
                'Homes With Zestimates': '870.2 K',
                'Within 5% of Sale Price': '40.19%',
                'Within 10% of Sale Price': '66.57%',
                'Within 20% of Sale Price': '87.99%',
            },
            {
                'Metropolitan Area': 'Baltimore',
                'Median Error': '6.19%',
                'Homes With Zestimates': '940.3 K',
                'Within 5% of Sale Price': '42.98%',
                'Within 10% of Sale Price': '66.45%',
                'Within 20% of Sale Price': '85.37%',
            },
            {
                'Metropolitan Area': 'Boston',
                'Median Error': '6.70%',
                'Homes With Zestimates': '1.6 M',
                'Within 5% of Sale Price': '39.50%',
                'Within 10% of Sale Price': '65.78%',
                'Within 20% of Sale Price': '87.28%',
            },
            {
                'Metropolitan Area': 'Charlotte',
                'Median Error': '5.85%',
                'Homes With Zestimates': '1.1 M',
                'Within 5% of Sale Price': '44.40%',
                'Within 10% of Sale Price': '69.88%',
                'Within 20% of Sale Price': '88.25%',
            },
            {
                'Metropolitan Area': 'Chicago',
                'Median Error': '7.12%',
                'Homes With Zestimates': '3.3 M',
                'Within 5% of Sale Price': '37.89%',
                'Within 10% of Sale Price': '62.90%',
                'Within 20% of Sale Price': '84.45%',
            },
            {
                'Metropolitan Area': 'Cincinnati',
                'Median Error': '7.31%',
                'Homes With Zestimates': '814.8 K',
                'Within 5% of Sale Price': '36.98%',
                'Within 10% of Sale Price': '61.68%',
                'Within 20% of Sale Price': '83.09%',
            },
            {
                'Metropolitan Area': 'Cleveland',
                'Median Error': '8.83%',
                'Homes With Zestimates': '781.2 K',
                'Within 5% of Sale Price': '30.89%',
                'Within 10% of Sale Price': '54.70%',
                'Within 20% of Sale Price': '79.50%',
            },
            {
                'Metropolitan Area': 'Colorado Springs',
                'Median Error': '4.83%',
                'Homes With Zestimates': '281.8 K',
                'Within 5% of Sale Price': '51.31%',
                'Within 10% of Sale Price': '76.59%',
                'Within 20% of Sale Price': '91.73%',
            },
            {
                'Metropolitan Area': 'Dallas-Fort Worth',
                'Median Error': '5.99%',
                'Homes With Zestimates': '2.6 M',
                'Within 5% of Sale Price': '43.26%',
                'Within 10% of Sale Price': '69.83%',
                'Within 20% of Sale Price': '88.98%',
            },
            {
                'Metropolitan Area': 'Denver',
                'Median Error': '5.14%',
                'Homes With Zestimates': '1.1 M',
                'Within 5% of Sale Price': '48.99%',
                'Within 10% of Sale Price': '75.87%',
                'Within 20% of Sale Price': '92.50%',
            },
            {
                'Metropolitan Area': 'Detroit',
                'Median Error': '8.08%',
                'Homes With Zestimates': '1.5 M',
                'Within 5% of Sale Price': '34.08%',
                'Within 10% of Sale Price': '58.02%',
                'Within 20% of Sale Price': '80.49%',
            },
            {
                'Metropolitan Area': 'Fort Collins',
                'Median Error': '5.38%',
                'Homes With Zestimates': '148.5 K',
                'Within 5% of Sale Price': '47.25%',
                'Within 10% of Sale Price': '72.85%',
                'Within 20% of Sale Price': '91.05%',
            },
            {
                'Metropolitan Area': 'Houston',
                'Median Error': '6.52%',
                'Homes With Zestimates': '2.4 M',
                'Within 5% of Sale Price': '40.40%',
                'Within 10% of Sale Price': '66.46%',
                'Within 20% of Sale Price': '87.13%',
            },
            {
                'Metropolitan Area': 'Jacksonville',
                'Median Error': '6.68%',
                'Homes With Zestimates': '709.3 K',
                'Within 5% of Sale Price': '39.95%',
                'Within 10% of Sale Price': '65.37%',
                'Within 20% of Sale Price': '85.65%',
            },
            {
                'Metropolitan Area': 'Kansas City',
                'Median Error': '6.60%',
                'Homes With Zestimates': '823.2 K',
                'Within 5% of Sale Price': '40.03%',
                'Within 10% of Sale Price': '65.59%',
                'Within 20% of Sale Price': '85.53%',
            },
            {
                'Metropolitan Area': 'Las Vegas',
                'Median Error': '4.52%',
                'Homes With Zestimates': '823.3 K',
                'Within 5% of Sale Price': '53.77%',
                'Within 10% of Sale Price': '78.35%',
                'Within 20% of Sale Price': '91.99%',
            },
            {
                'Metropolitan Area': 'Los Angeles-Long Beach-Anaheim',
                'Median Error': '6.67%',
                'Homes With Zestimates': '3.0 M',
                'Within 5% of Sale Price': '39.61%',
                'Within 10% of Sale Price': '65.53%',
                'Within 20% of Sale Price': '86.49%',
            },
            {
                'Metropolitan Area': 'Miami-Fort Lauderdale',
                'Median Error': '7.68%',
                'Homes With Zestimates': '2.5 M',
                'Within 5% of Sale Price': '35.43%',
                'Within 10% of Sale Price': '60.01%',
                'Within 20% of Sale Price': '83.88%',
            },
            {
                'Metropolitan Area': 'Minneapolis-St Paul',
                'Median Error': '5.89%',
                'Homes With Zestimates': '1.4 M',
                'Within 5% of Sale Price': '43.72%',
                'Within 10% of Sale Price': '70.32%',
                'Within 20% of Sale Price': '89.47%',
            },
            {
                'Metropolitan Area': 'Nashville',
                'Median Error': '6.83%',
                'Homes With Zestimates': '893.2 K',
                'Within 5% of Sale Price': '39.16%',
                'Within 10% of Sale Price': '63.71%',
                'Within 20% of Sale Price': '82.98%',
            },
            {
                'Metropolitan Area': 'New York',
                'Median Error': '7.74%',
                'Homes With Zestimates': '5.5 M',
                'Within 5% of Sale Price': '35.32%',
                'Within 10% of Sale Price': '59.90%',
                'Within 20% of Sale Price': '83.29%',
            },
            {
                'Metropolitan Area': 'Orlando',
                'Median Error': '5.91%',
                'Homes With Zestimates': '986.8 K',
                'Within 5% of Sale Price': '44.27%',
                'Within 10% of Sale Price': '69.61%',
                'Within 20% of Sale Price': '89.02%',
            },
            {
                'Metropolitan Area': 'Philadelphia',
                'Median Error': '7.88%',
                'Homes With Zestimates': '2.1 M',
                'Within 5% of Sale Price': '34.63%',
                'Within 10% of Sale Price': '58.88%',
                'Within 20% of Sale Price': '82.12%',
            },
            {
                'Metropolitan Area': 'Phoenix',
                'Median Error': '5.47%',
                'Homes With Zestimates': '1.8 M',
                'Within 5% of Sale Price': '46.81%',
                'Within 10% of Sale Price': '72.45%',
                'Within 20% of Sale Price': '90.13%',
            },
            {
                'Metropolitan Area': 'Pittsburgh',
                'Median Error': '11.21%',
                'Homes With Zestimates': '865.0 K',
                'Within 5% of Sale Price': '26.25%',
                'Within 10% of Sale Price': '46.32%',
                'Within 20% of Sale Price': '69.69%',
            },
            {
                'Metropolitan Area': 'Portland',
                'Median Error': '5.69%',
                'Homes With Zestimates': '867.7 K',
                'Within 5% of Sale Price': '45.10%',
                'Within 10% of Sale Price': '71.31%',
                'Within 20% of Sale Price': '89.27%',
            },
            {
                'Metropolitan Area': 'Raleigh',
                'Median Error': '4.90%',
                'Homes With Zestimates': '565.1 K',
                'Within 5% of Sale Price': '50.95%',
                'Within 10% of Sale Price': '77.23%',
                'Within 20% of Sale Price': '92.40%',
            },
            {
                'Metropolitan Area': 'Riverside',
                'Median Error': '5.87%',
                'Homes With Zestimates': '1.4 M',
                'Within 5% of Sale Price': '44.34%',
                'Within 10% of Sale Price': '68.59%',
                'Within 20% of Sale Price': '85.86%',
            },
            {
                'Metropolitan Area': 'Sacramento',
                'Median Error': '5.45%',
                'Homes With Zestimates': '798.0 K',
                'Within 5% of Sale Price': '46.88%',
                'Within 10% of Sale Price': '72.62%',
                'Within 20% of Sale Price': '89.69%',
            },
            {
                'Metropolitan Area': 'San Antonio',
                'Median Error': '6.86%',
                'Homes With Zestimates': '1.0 M',
                'Within 5% of Sale Price': '38.69%',
                'Within 10% of Sale Price': '64.27%',
                'Within 20% of Sale Price': '84.70%',
            },
            {
                'Metropolitan Area': 'San Diego',
                'Median Error': '6.15%',
                'Homes With Zestimates': '937.1 K',
                'Within 5% of Sale Price': '42.56%',
                'Within 10% of Sale Price': '68.63%',
                'Within 20% of Sale Price': '88.32%',
            },
            {
                'Metropolitan Area': 'San Francisco',
                'Median Error': '7.75%',
                'Homes With Zestimates': '1.3 M',
                'Within 5% of Sale Price': '34.87%',
                'Within 10% of Sale Price': '59.92%',
                'Within 20% of Sale Price': '84.35%',
            },
            {
                'Metropolitan Area': 'Seattle',
                'Median Error': '5.86%',
                'Homes With Zestimates': '1.4 M',
                'Within 5% of Sale Price': '44.16%',
                'Within 10% of Sale Price': '70.39%',
                'Within 20% of Sale Price': '89.55%',
            },
            {
                'Metropolitan Area': 'St. Louis',
                'Median Error': '8.00%',
                'Homes With Zestimates': '1.0 M',
                'Within 5% of Sale Price': '34.46%',
                'Within 10% of Sale Price': '58.50%',
                'Within 20% of Sale Price': '80.41%',
            },
            {
                'Metropolitan Area': 'Tampa',
                'Median Error': '7.53%',
                'Homes With Zestimates': '1.3 M',
                'Within 5% of Sale Price': '35.68%',
                'Within 10% of Sale Price': '60.66%',
                'Within 20% of Sale Price': '83.22%',
            },
            {
                'Metropolitan Area': 'Tucson',
                'Median Error': '6.14%',
                'Homes With Zestimates': '386.9 K',
                'Within 5% of Sale Price': '42.96%',
                'Within 10% of Sale Price': '67.95%',
                'Within 20% of Sale Price': '87.77%',
            },
            {
                'Metropolitan Area': 'Washington',
                'Median Error': '4.89%',
                'Homes With Zestimates': '2.0 M',
                'Within 5% of Sale Price': '50.86%',
                'Within 10% of Sale Price': '76.28%',
                'Within 20% of Sale Price': '91.70%',
            },
        ],
    },
    States: {
        headers: [
            'State',
            'Median Error',
            'Homes With Zestimates',
            'Within 5% of Sales Price',
            'Within 10% of Sales Price',
            'Within 20% of Sales Price',
        ],
        data: [
            {
                State: 'Alabama',
                'Median Error': '8.23%',
                'Homes With Zestimates': '1.8 M',
                'Within 5% of Sale Price': '34.16%',
                'Within 10% of Sale Price': '56.45%',
                'Within 20% of Sale Price': '76.95%',
            },
            {
                State: 'Alaska',
                'Median Error': 'NA',
                'Homes With Zestimates': '247.1 K',
                'Within 5% of Sale Price': 'NA',
                'Within 10% of Sale Price': 'NA',
                'Within 20% of Sale Price': 'NA',
            },
            {
                State: 'Arizona',
                'Median Error': '5.96%',
                'Homes With Zestimates': '2.7 M',
                'Within 5% of Sale Price': '43.81%',
                'Within 10% of Sale Price': '68.89%',
                'Within 20% of Sale Price': '87.73%',
            },
            {
                State: 'Arkansas',
                'Median Error': '8.33%',
                'Homes With Zestimates': '1.1 M',
                'Within 5% of Sale Price': '34.87%',
                'Within 10% of Sale Price': '55.89%',
                'Within 20% of Sale Price': '75.75%',
            },
            {
                State: 'California',
                'Median Error': '6.51%',
                'Homes With Zestimates': '10.9 M',
                'Within 5% of Sale Price': '40.79%',
                'Within 10% of Sale Price': '65.71%',
                'Within 20% of Sale Price': '85.56%',
            },
            {
                State: 'Colorado',
                'Median Error': '5.54%',
                'Homes With Zestimates': '2.3 M',
                'Within 5% of Sale Price': '46.20%',
                'Within 10% of Sale Price': '71.89%',
                'Within 20% of Sale Price': '89.57%',
            },
            {
                State: 'Connecticut',
                'Median Error': '7.71%',
                'Homes With Zestimates': '1.3 M',
                'Within 5% of Sale Price': '34.47%',
                'Within 10% of Sale Price': '60.59%',
                'Within 20% of Sale Price': '84.56%',
            },
            {
                State: 'Delaware',
                'Median Error': '9.42%',
                'Homes With Zestimates': '441.0 K',
                'Within 5% of Sale Price': '29.77%',
                'Within 10% of Sale Price': '52.20%',
                'Within 20% of Sale Price': '77.97%',
            },
            {
                State: 'District of Columbia',
                'Median Error': '7.68%',
                'Homes With Zestimates': '192.4 K',
                'Within 5% of Sale Price': '35.48%',
                'Within 10% of Sale Price': '59.95%',
                'Within 20% of Sale Price': '82.79%',
            },
            {
                State: 'Florida',
                'Median Error': '7.39%',
                'Homes With Zestimates': '9.6 M',
                'Within 5% of Sale Price': '36.61%',
                'Within 10% of Sale Price': '61.31%',
                'Within 20% of Sale Price': '83.78%',
            },
            {
                State: 'Georgia',
                'Median Error': '7.13%',
                'Homes With Zestimates': '3.8 M',
                'Within 5% of Sale Price': '38.21%',
                'Within 10% of Sale Price': '62.00%',
                'Within 20% of Sale Price': '82.37%',
            },
            {
                State: 'Hawaii',
                'Median Error': '8.00%',
                'Homes With Zestimates': '534.1 K',
                'Within 5% of Sale Price': '33.93%',
                'Within 10% of Sale Price': '58.49%',
                'Within 20% of Sale Price': '81.62%',
            },
            {
                State: 'Idaho',
                'Median Error': '5.67%',
                'Homes With Zestimates': '850.3 K',
                'Within 5% of Sale Price': '45.51%',
                'Within 10% of Sale Price': '70.45%',
                'Within 20% of Sale Price': '88.96%',
            },
            {
                State: 'Illinois',
                'Median Error': '8.19%',
                'Homes With Zestimates': '4.3 M',
                'Within 5% of Sale Price': '33.81%',
                'Within 10% of Sale Price': '57.22%',
                'Within 20% of Sale Price': '79.48%',
            },
            {
                State: 'Indiana',
                'Median Error': '7.38%',
                'Homes With Zestimates': '2.5 M',
                'Within 5% of Sale Price': '36.86%',
                'Within 10% of Sale Price': '60.75%',
                'Within 20% of Sale Price': '81.50%',
            },
            {
                State: 'Iowa',
                'Median Error': '7.77%',
                'Homes With Zestimates': '1.3 M',
                'Within 5% of Sale Price': '35.57%',
                'Within 10% of Sale Price': '59.06%',
                'Within 20% of Sale Price': '80.57%',
            },
            {
                State: 'Kansas',
                'Median Error': '7.27%',
                'Homes With Zestimates': '1.1 M',
                'Within 5% of Sale Price': '36.87%',
                'Within 10% of Sale Price': '61.59%',
                'Within 20% of Sale Price': '82.38%',
            },
            {
                State: 'Kentucky',
                'Median Error': '8.03%',
                'Homes With Zestimates': '1.5 M',
                'Within 5% of Sale Price': '34.78%',
                'Within 10% of Sale Price': '57.65%',
                'Within 20% of Sale Price': '78.43%',
            },
            {
                State: 'Louisiana',
                'Median Error': '9.26%',
                'Homes With Zestimates': '1.4 M',
                'Within 5% of Sale Price': '31.89%',
                'Within 10% of Sale Price': '52.79%',
                'Within 20% of Sale Price': '73.70%',
            },
            {
                State: 'Maine',
                'Median Error': '9.92%',
                'Homes With Zestimates': '503.8 K',
                'Within 5% of Sale Price': '28.28%',
                'Within 10% of Sale Price': '50.40%',
                'Within 20% of Sale Price': '74.32%',
            },
            {
                State: 'Maryland',
                'Median Error': '6.04%',
                'Homes With Zestimates': '2.1 M',
                'Within 5% of Sale Price': '43.62%',
                'Within 10% of Sale Price': '67.65%',
                'Within 20% of Sale Price': '86.18%',
            },
            {
                State: 'Massachusetts',
                'Median Error': '6.91%',
                'Homes With Zestimates': '2.3 M',
                'Within 5% of Sale Price': '38.38%',
                'Within 10% of Sale Price': '64.29%',
                'Within 20% of Sale Price': '86.13%',
            },
            {
                State: 'Michigan',
                'Median Error': '8.77%',
                'Homes With Zestimates': '3.8 M',
                'Within 5% of Sale Price': '31.87%',
                'Within 10% of Sale Price': '54.74%',
                'Within 20% of Sale Price': '77.62%',
            },
            {
                State: 'Minnesota',
                'Median Error': '6.72%',
                'Homes With Zestimates': '2.2 M',
                'Within 5% of Sale Price': '39.52%',
                'Within 10% of Sale Price': '64.96%',
                'Within 20% of Sale Price': '85.51%',
            },
            {
                State: 'Mississippi',
                'Median Error': '7.88%',
                'Homes With Zestimates': '870.3 K',
                'Within 5% of Sale Price': '36.22%',
                'Within 10% of Sale Price': '57.76%',
                'Within 20% of Sale Price': '77.42%',
            },
            {
                State: 'Missouri',
                'Median Error': '7.97%',
                'Homes With Zestimates': '2.4 M',
                'Within 5% of Sale Price': '34.64%',
                'Within 10% of Sale Price': '58.31%',
                'Within 20% of Sale Price': '80.12%',
            },
            {
                State: 'Montana',
                'Median Error': '7.92%',
                'Homes With Zestimates': '457.7 K',
                'Within 5% of Sale Price': '34.49%',
                'Within 10% of Sale Price': '58.98%',
                'Within 20% of Sale Price': '80.95%',
            },
            {
                State: 'Nebraska',
                'Median Error': '6.45%',
                'Homes With Zestimates': '683.4 K',
                'Within 5% of Sale Price': '41.28%',
                'Within 10% of Sale Price': '65.83%',
                'Within 20% of Sale Price': '84.83%',
            },
            {
                State: 'Nevada',
                'Median Error': '4.81%',
                'Homes With Zestimates': '1.1 M',
                'Within 5% of Sale Price': '51.39%',
                'Within 10% of Sale Price': '75.60%',
                'Within 20% of Sale Price': '90.56%',
            },
            {
                State: 'New Hampshire',
                'Median Error': '7.38%',
                'Homes With Zestimates': '607.8 K',
                'Within 5% of Sale Price': '36.38%',
                'Within 10% of Sale Price': '61.13%',
                'Within 20% of Sale Price': '82.98%',
            },
            {
                State: 'New Jersey',
                'Median Error': '7.45%',
                'Homes With Zestimates': '3.0 M',
                'Within 5% of Sale Price': '36.36%',
                'Within 10% of Sale Price': '61.34%',
                'Within 20% of Sale Price': '84.32%',
            },
            {
                State: 'New Mexico',
                'Median Error': '6.65%',
                'Homes With Zestimates': '697.0 K',
                'Within 5% of Sale Price': '40.15%',
                'Within 10% of Sale Price': '64.39%',
                'Within 20% of Sale Price': '84.57%',
            },
            {
                State: 'New York',
                'Median Error': '9.15%',
                'Homes With Zestimates': '5.5 M',
                'Within 5% of Sale Price': '30.75%',
                'Within 10% of Sale Price': '53.32%',
                'Within 20% of Sale Price': '77.54%',
            },
            {
                State: 'North Carolina',
                'Median Error': '6.58%',
                'Homes With Zestimates': '4.3 M',
                'Within 5% of Sale Price': '40.65%',
                'Within 10% of Sale Price': '64.70%',
                'Within 20% of Sale Price': '83.61%',
            },
            {
                State: 'North Dakota',
                'Median Error': '6.85%',
                'Homes With Zestimates': '221.5 K',
                'Within 5% of Sale Price': '39.42%',
                'Within 10% of Sale Price': '63.49%',
                'Within 20% of Sale Price': '84.13%',
            },
            {
                State: 'Ohio',
                'Median Error': '8.40%',
                'Homes With Zestimates': '4.3 M',
                'Within 5% of Sale Price': '33.06%',
                'Within 10% of Sale Price': '56.28%',
                'Within 20% of Sale Price': '78.53%',
            },
            {
                State: 'Oklahoma',
                'Median Error': '7.38%',
                'Homes With Zestimates': '1.5 M',
                'Within 5% of Sale Price': '37.41%',
                'Within 10% of Sale Price': '59.97%',
                'Within 20% of Sale Price': '79.09%',
            },
            {
                State: 'Oregon',
                'Median Error': '6.39%',
                'Homes With Zestimates': '1.6 M',
                'Within 5% of Sale Price': '41.41%',
                'Within 10% of Sale Price': '66.37%',
                'Within 20% of Sale Price': '85.85%',
            },
            {
                State: 'Pennsylvania',
                'Median Error': '9.32%',
                'Homes With Zestimates': '4.6 M',
                'Within 5% of Sale Price': '30.42%',
                'Within 10% of Sale Price': '52.55%',
                'Within 20% of Sale Price': '75.67%',
            },
            {
                State: 'Rhode Island',
                'Median Error': '6.99%',
                'Homes With Zestimates': '376.0 K',
                'Within 5% of Sale Price': '38.33%',
                'Within 10% of Sale Price': '63.77%',
                'Within 20% of Sale Price': '85.84%',
            },
            {
                State: 'South Carolina',
                'Median Error': '7.26%',
                'Homes With Zestimates': '2.1 M',
                'Within 5% of Sale Price': '37.66%',
                'Within 10% of Sale Price': '61.28%',
                'Within 20% of Sale Price': '81.97%',
            },
            {
                State: 'South Dakota',
                'Median Error': '7.39%',
                'Homes With Zestimates': '306.3 K',
                'Within 5% of Sale Price': '37.24%',
                'Within 10% of Sale Price': '60.83%',
                'Within 20% of Sale Price': '82.64%',
            },
            {
                State: 'Tennessee',
                'Median Error': '8.55%',
                'Homes With Zestimates': '2.9 M',
                'Within 5% of Sale Price': '33.27%',
                'Within 10% of Sale Price': '55.24%',
                'Within 20% of Sale Price': '75.22%',
            },
            {
                State: 'Texas',
                'Median Error': '6.73%',
                'Homes With Zestimates': '10.1 M',
                'Within 5% of Sale Price': '39.50%',
                'Within 10% of Sale Price': '64.83%',
                'Within 20% of Sale Price': '85.20%',
            },
            {
                State: 'Utah',
                'Median Error': '5.27%',
                'Homes With Zestimates': '1.3 M',
                'Within 5% of Sale Price': '47.92%',
                'Within 10% of Sale Price': '74.78%',
                'Within 20% of Sale Price': '91.72%',
            },
            {
                State: 'Vermont',
                'Median Error': '11.74%',
                'Homes With Zestimates': '268.2 K',
                'Within 5% of Sale Price': '23.66%',
                'Within 10% of Sale Price': '44.29%',
                'Within 20% of Sale Price': '67.96%',
            },
            {
                State: 'Virginia',
                'Median Error': '5.53%',
                'Homes With Zestimates': '3.0 M',
                'Within 5% of Sale Price': '46.44%',
                'Within 10% of Sale Price': '70.86%',
                'Within 20% of Sale Price': '87.27%',
            },
            {
                State: 'Washington',
                'Median Error': '6.17%',
                'Homes With Zestimates': '2.8 M',
                'Within 5% of Sale Price': '42.54%',
                'Within 10% of Sale Price': '67.75%',
                'Within 20% of Sale Price': '86.87%',
            },
            {
                State: 'West Virginia',
                'Median Error': '10.72%',
                'Homes With Zestimates': '615.5 K',
                'Within 5% of Sale Price': '28.11%',
                'Within 10% of Sale Price': '47.81%',
                'Within 20% of Sale Price': '69.46%',
            },
            {
                State: 'Wisconsin',
                'Median Error': '7.72%',
                'Homes With Zestimates': '2.2 M',
                'Within 5% of Sale Price': '35.36%',
                'Within 10% of Sale Price': '59.64%',
                'Within 20% of Sale Price': '81.89%',
            },
            {
                State: 'Wyoming',
                'Median Error': '7.67%',
                'Homes With Zestimates': '245.0 K',
                'Within 5% of Sale Price': '36.14%',
                'Within 10% of Sale Price': '59.29%',
                'Within 20% of Sale Price': '81.14%',
            },
        ],
    },
    National: {
        headers: [
            'Region',
            'Median Error',
            'Homes With Zestimates',
            'Within 5% of Sales Price',
            'Within 10% of Sales Price',
            'Within 20% of Sales Price',
        ],
        data: [
            {
                Region: 'All 50 States',
                'Median Error': '7.20%',
                'Homes With Zestimates': '116.9 M',
                'Within 5% of Sale Price': '37.73%',
                'Within 10% of Sale Price': '61.81%',
                'Within 20% of Sale Price': '82.61%',
            },
        ],
    },
};
